import Data from '../data/news.json';
import { useState } from "react";
import { langData } from "../libs/Utils";
import { convertMarkdownToHTML } from "../libs/Sanitizer";

export const News = (props) => {
    const { lang } = props;
    const [count, setCount] = useState(5);
    const nowData = langData(lang, Data);
    const addCount = () => {
        setCount(count + 5);
    }
    const maxLength = nowData.length;


    return (
        <div id="news">
            <h1>NEWS</h1>
            <ul id="newslist">
                {nowData.slice(0, count).map((d, i) =>
                    <li key={i}>
                        <span className="date" dangerouslySetInnerHTML={convertMarkdownToHTML(d.date)} />
                        <span className="news_content" dangerouslySetInnerHTML={convertMarkdownToHTML(d.content)} />
                    </li>)}
            </ul>
            <div id="showmore" style={{ display: (maxLength < count ? "none" : "flex") }}><p onClick={() => { addCount() }}>{lang === "en" ? "▼ Show more" : "▼ 続きを表示"}</p></div>
        </div>
    );
};